import { hasAds } from 'mk/bazaar/common/userUtils';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import SearchPanel from 'mk2/apps/forum/components/SearchPanel';
import { PostDetailViewType, Props } from 'mk2/apps/forum/containers/PostDetail/PostDetailPage';
import {
    PostDetailRelated,
    PostDetailRelatedPlaceholder,
} from 'mk2/apps/forum/containers/PostDetail/PostDetailRelated';
import { forumSearchUrl } from 'mk2/apps/forum/urls';
import { BrandDaysPosts } from 'mk2/apps/home/components/BrandDaysPosts';
import AdSlot from 'mk2/containers/AdSlot/AdSlot';
import LoadingSwitch from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './PostDetailRight.mscss';

export class PostDetailRight extends React.PureComponent<Props> {

    public render() {
        const { isMobile, similarPosts, recentPosts, loadingState } = this.props;

        return isMobile ? null : (
            <LoadingSwitch
                loadingState={loadingState}
                onLoad={this.load}
                onRenderInit={this.renderInit}
                onRenderSuccess={this.renderSuccess}
                onRenderFailure={this.renderFailure}
                onFailureToast={this.failureToast}
                hasData={(recentPosts && recentPosts.length > 0) || (similarPosts && similarPosts.length > 0)}
            />
        );
    }

    private load = () => {/* nothing to do */};

    private renderInit = () => {
        const { viewType, requestUser } = this.props;
        const isAskAnExpert = viewType === PostDetailViewType.AskAnExpert;
        const isContest = viewType === PostDetailViewType.Contest;

        return (
            <>
                {this.renderSearchBox()}

                {!isContest && this.renderRectangleAd()}

                <PostDetailRelatedPlaceholder
                    isAskAnExpert={isAskAnExpert}
                    isContest={isContest}
                    requestUser={requestUser}
                />
            </>
        );
    };

    private renderSuccess = () => {
        const {
            isMobile, location, requestUser, recentPosts, post, similarPosts, brandDaysCampaign, brandDaysPosts,
            viewType,
        } = this.props;

        const isAskAnExpert = viewType === PostDetailViewType.AskAnExpert;
        const isContest = viewType === PostDetailViewType.Contest;
        const showBrandDays = !!brandDaysCampaign && brandDaysPosts.length > 0 && hasAds(requestUser);

        return (
            <>
                {this.renderSearchBox()}

                {showBrandDays && (
                    <BrandDaysPosts
                        className={styles.PostDetailRight__brandDaysPosts}
                        brandDaysCampaign={brandDaysCampaign}
                        brandDaysPosts={brandDaysPosts}
                    />
                )}

                {!isContest && !post.isNoAds && this.renderRectangleAd()}

                <PostDetailRelated
                    isAskAnExpert={isAskAnExpert}
                    isContest={isContest}
                    isMobile={isMobile}
                    location={location}
                    requestUser={requestUser}
                    similarPosts={similarPosts}
                    recentPosts={recentPosts}
                />
            </>
        );
    };

    private renderFailure = () => null; /* nothing to render */

    private failureToast = () => {/* nothing to do */};

    private renderSearchBox = () => {
        const { viewType } = this.props;

        if (viewType === PostDetailViewType.Contest || ACTIVE_SERVER_ID === 207) {
            return null;
        }

        return (
            <SearchPanel
                key="search"
                onSubmit={this.onSearch}
                className={styles.PostDetailRight__searchPanel}
            />
        );
    };

    private renderRectangleAd = () => {
        const { location } = this.props;

        // Chceme aby sa adslot nacital uz pocas loadingu, a tak sme skor zobrazili reklamu.
        // Preto ma rovnaky key="" v renderInit aj v renderSuccess()
        return (
            /*<AdformInview
                key="advertisement"
                placementId={ACTIVE_SERVER_ID === 201 ? 544773 : 402804}
                passback={*/
                    <AdSlot
                        key="advertisement-passback"
                        zone="Forum Thread - Rectangle 1 (Desktop)"
                        location={location}
                        marginBottomWithAd={10}
                    />/*
                }
                marginBottomWithAd={10}
            />*/
        );
    };

    private onSearch = (query: string) => {
        this.props.history.push(url(forumSearchUrl, {}, { q: query }));
    };
}
